/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { TimeoutError } from "exception/TimeoutError";
import { ErrorDialog } from "components/Common/ErrorDialog";
import { SpinnerDelay } from "components/Common/SpinnerDelay";
import { SystemErrorDialog } from "components/Common/SystemErrorDialog";
import { MultipleWrapper } from "components/Multiple/MultipleWrapper";
import { useDayJob } from "hooks/GetDayJobHook";
import moment, { Moment } from "moment";
import { FC, useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useInterval } from "react-use";
import { Const } from "const";

export const Multiple: FC = () => {
  const { t } = useTranslation();
  const [date, setDate] = useState<Moment>(moment());
  const { loading, error, value, retry } = useDayJob(date);
  const valueRef = useRef(value);

  useInterval(() => {
    if (!loading) {
      retry();
    }
  }, Const.taskInterval);

  const [first, setFirst] = useState(true);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    setFirst(true);
  }, [date]);
  useEffect(() => {
    if (!loading) {
      if (error) {
        setFirst(false);
        setShowError((pre) => pre || first);
      }
      if (value?.taskInfos) {
        setFirst(false);
      }
      if (first || value) {
        valueRef.current = value;
      }
    }
  }, [loading, error, value, first]);

  const isTimeout = error && error instanceof TimeoutError;
  return (
    <>
      <MultipleWrapper
        awvInfos={(value ?? valueRef.current)?.awvInfos ?? []}
        tasks={(value ?? valueRef.current)?.taskInfos}
        date={date}
        setDate={setDate}
      />
      {first && loading && <SpinnerDelay />}
      {isTimeout ? (
        <ErrorDialog
          open={showError}
          message={t("AWVUI-MSG83")}
          positiveButtonText={t("AWVUI-MSG11")}
          onPositiveButtonClick={() => {
            // NOTE Anything is not display when time out occurred.
            setShowError(false);
          }}
        />
      ) : (
        <SystemErrorDialog
          open={showError}
          error={error}
          onClose={() => {
            setShowError(false);
          }}
        />
      )}
    </>
  );
};
